var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "form", attrs: { id: "variant" } }, [
    _c(
      "div",
      { staticClass: "form-wrapper" },
      [
        _c("p", { staticClass: "section-title" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("p", { staticClass: "section-description" }, [
          _vm._v(_vm._s(_vm.text))
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.error_material.status &&
                  _vm.submitted &&
                  !this.form["material_name"],
                expression:
                  "\n\t\t\t\terror_material.status &&\n\t\t\t\t\tsubmitted &&\n\t\t\t\t\t!this.form['material_name']\n\t\t\t"
              }
            ],
            staticClass: "form-error"
          },
          [_vm._v(_vm._s(_vm.error_material.message))]
        ),
        _vm._v(" "),
        _c(
          "modal",
          _vm._b(
            { ref: "variant", on: { submitted: _vm.setMaterial } },
            "modal",
            {
              product_handle: _vm.product_handle,
              product_title: _vm.product_title,
              success: _vm.success
            },
            false
          )
        ),
        _vm._v(" "),
        _c("textarea", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.message,
              expression: "form.message"
            }
          ],
          attrs: {
            rows: "8",
            id: "message",
            placeholder: this.$translations.form.message
          },
          domProps: { value: _vm.form.message },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "message", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("name") && _vm.submitted,
                expression: "errors.has('name') && submitted"
              }
            ],
            staticClass: "form-error"
          },
          [_vm._v(_vm._s(_vm.errors.first("name")))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required",
              expression: "'required'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.name,
              expression: "form.name"
            }
          ],
          attrs: {
            id: "name",
            name: "name",
            type: "text",
            placeholder: this.$translations.form.name
          },
          domProps: { value: _vm.form.name },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "name", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.errors.has("email") && _vm.submitted,
                expression: "errors.has('email') && submitted"
              }
            ],
            staticClass: "form-error"
          },
          [_vm._v(_vm._s(_vm.errors.first("email")))]
        ),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|email",
              expression: "'required|email'"
            },
            {
              name: "model",
              rawName: "v-model",
              value: _vm.form.email,
              expression: "form.email"
            }
          ],
          attrs: {
            name: "email",
            id: "email",
            type: "email",
            placeholder: this.$translations.form.email
          },
          domProps: { value: _vm.form.email },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.form, "email", $event.target.value)
            }
          }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: {
            type: "hidden",
            id: "gclid_field",
            name: "gclid_field",
            value: ""
          }
        }),
        _vm._v(" "),
        _c("input", {
          attrs: { type: "hidden", id: "cid_field", name: "cid", value: "" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "terms" }, [
          _c("div", { staticClass: "checkbox-wrapper" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.agreed_terms.status,
                  expression: "agreed_terms.status"
                }
              ],
              attrs: { type: "checkbox", name: "conditions", id: "conditions" },
              domProps: {
                checked: Array.isArray(_vm.agreed_terms.status)
                  ? _vm._i(_vm.agreed_terms.status, null) > -1
                  : _vm.agreed_terms.status
              },
              on: {
                change: [
                  function($event) {
                    var $$a = _vm.agreed_terms.status,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.agreed_terms,
                            "status",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.agreed_terms,
                            "status",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.agreed_terms, "status", $$c)
                    }
                  },
                  function($event) {
                    _vm.agreed_terms.error = false
                  }
                ]
              }
            }),
            _vm._v(" "),
            _c("a", { attrs: { target: "_blank", href: _vm.terms } }, [
              _vm._v(
                "\n\t\t\t\t\t" +
                  _vm._s(this.$translations.cart.terms_text) +
                  "\n\t\t\t\t"
              )
            ])
          ]),
          _vm._v(" "),
          _vm.agreed_terms.error
            ? _c("div", { staticClass: "form-error" }, [
                _vm._v(
                  "\n\t\t\t\t" +
                    _vm._s(this.$translations.cart.terms_error) +
                    "\n\t\t\t"
                )
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            class: ["btn-submit", "varianter", { "btn-loading": _vm.loading }],
            on: { click: _vm.submit }
          },
          [_vm._v("\n\t\t\t" + _vm._s(this.$translations.form.send) + "\n\t\t")]
        ),
        _vm._v(" "),
        _vm.error
          ? _c("div", { staticClass: "form-error" }, [
              _vm._v(
                "\n\t\t\t" + _vm._s(this.$translations.form.error) + "\n\t\t"
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.success
          ? _c("div", { staticClass: "form-success" }, [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(this.$translations.form.post_success) +
                  "\n\t\t"
              )
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }